import { Dispatch, MutableRefObject, SetStateAction, useCallback } from 'react';
import { stopLiveSession } from '@utils/api/realtime/live-transcript.ts';
import { LiveSessionStatus } from '@utils/types/editors/live-transcript.ts';

type Props = {
  sessionId: string;
  generation: MutableRefObject<number>;
  setOwner: Dispatch<SetStateAction<LiveSessionStatus | null>>;
  setError: Dispatch<
    SetStateAction<'load' | 'save' | 'conflict' | 'connection' | null>
  >;
};

export const useLiveTranscriptStop = ({
  sessionId,
  generation,
  setOwner,
  setError
}: Props) =>
  useCallback(async () => {
    const active = generation.current;
    try {
      const status = await stopLiveSession(sessionId);
      if (generation.current === active) setOwner(status);
    } catch {
      if (generation.current === active) setError('connection');
    }
  }, [generation, sessionId, setError, setOwner]);
